var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLogin && _vm.user)?_c('div',{staticClass:"is-online",class:{ online: _vm.isOnline }}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }